var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{attrs:{"heading":_vm.banner.heading,"subtitle":_vm.banner.subtitle,"icon":_vm.banner.icon,"iconSize":"xxx-large"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }